import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import SearchComponent from '../../PricingHub/SearchComponent';

class ProductSummarySearchForm extends SearchComponent {
  searchInputs = [
    {
      label: 'label.startDate',
      name: 'startDate',
      type: 'date',
    },
    {
      label: 'label.endDate',
      name: 'endDate',
      type: 'date',
    },
    {
      label: 'label.billType',
      name: 'billType',
      type: 'select',
      tOptions: 'selections:billUnitType',
      isClearable: true,
    },
    {
      label: 'label.accountType',
      name: 'accountType',
      type: 'select',
      tOptions: 'selections:accountType',
      isClearable: true,
    },
    {
      label: 'label.billStatus',
      name: 'billStatus',
      tOptions: 'selections:invoiceStatus',
      isClearable: true,
      type: 'select',
    },
    {
      label: 'label.minimumBillThreshold',
      name: 'minBillThreshold',
      type: 'number',
    },
    {
      label: 'label.paymentMethod',
      name: 'paymentMethod',
      tOptions: 'selections:paymentMethod',
      isClearable: true,
      type: 'select',
    },
    {
      label: 'label.billingDom',
      name: 'billingDom',
      type: 'number',
    },
  ];

  btnSpan = 'col-md-12';
}

ProductSummarySearchForm.propTypes = {
  onSubmit: PropTypes.func,
  isSubmitting: PropTypes.bool,
};

ProductSummarySearchForm.defaultProps = {
  isSubmitting: false,
};

export default withTranslation('common')(ProductSummarySearchForm);
